import actionTypes from '../constants/action-types';

const initWelcomeTour = () => ({
  type: actionTypes.INIT_WELCOME_TOUR,
});

export default initWelcomeTour;
